module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAp0lEQVR4AWMYHKCBW+I/OyPjfyCTNAwD5wTV/q/hU/ivwMxGvgEgfERA5b8fGx+5BiAw1EukGXBBxuD/NQsvMA3kg9k/bt/7jwegGnDFwOn/n4+f/l81doW75JKqxf9X0xcSZ8B5ce3/l9Wt4Jqvmrr//37jNj4H4AkDS/3/XKU2/xmqbPFhTAOOi6r/9wsygSkgzYB1ilr/lTItQRKkG4DkZNLw8AAAFEYqIt771hYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/JO.png
// module id = 1176
// module chunks = 0